











































































































































































































import CardPanel from '@/components/common/CardPanel.vue'
import { Component, Ref } from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import { ElForm } from 'element-ui/types/form'
import { getDataContent } from '@/request/apis/common'
import { getConfigs, createTask } from '@/request/apis/AdvancedRequest'
import SelectPanel from '@/components/common/SelectPanel.vue'
import SimpleUploader from "@/components/common/SimpleUploader.vue"
import { getMarkers } from "@/request/apis/CellTypeAnnotationRequest";
import ParamsDialogWrapper from "@/components/common/ParamsDialogWrapper.vue"
import CascaderSelect from "@/components/common/CascaderSelect.vue";

@Component({
  components: {
    CascaderSelect,
    CardPanel,
    SelectPanel,
    SimpleUploader,
    ParamsDialogWrapper
  }
})
export default class AdvancedAnalysisForm extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('data-textarea') readonly dataTextarea!: HTMLInputElement
  @Ref('config-textarea') readonly configTextarea!: HTMLInputElement

  private configsList: any[] = []
  private markersList: any[] = []
  private loadingSelect: boolean = false
  private loadingProcessButton: boolean = false
  private type: string = 'AdvancedDownstreamAnalysis'
  private saveParams: object = {}
  private filterName: string = ''
  private form: any = {
    inputType: 'choose', // choose | file
    chooseData: '', // 选择的数据
    dataID: '', //上传的文件ID
    dataContent: '', // 文本内容
    markerType: 'choose', // choose | file
    markerData: '', // 选择的参数数据
    markerID: '', // 上传的参数数据
    configType: 'choose', // choose | file
    configData: '', // 选择的参数数据
    configID: '', //上传的配置文件ID
    configContent: '', // 文本内容
  }

  get id () {
    return this.$route.params.id
  }

  /**
   * 上传配置文件成功返回数据内容和ID
   */
  private uploadConfigSuccess (event: any) {
    this.form.configContent = event.detail.fileContent
    this.form.configID = event.detail.fileId
  }

  /**
   * 根据选择数据获取config
   */
  private async getConfigs () {
    this.configsList = await getConfigs(null, this.form.chooseData).start()
    this.configsList = this.configsList.map((item: string) => {
      return item.split('.yaml')[0]
    })
    this.form.configData = this.configsList[0]
  }

  /**
   * 根据选择数据获取marker
   */
  private async getMarker () {
    this.markersList = await getMarkers(null).start()
    this.form.markerData = this.markersList[0]
  }

  /**
   * 根据选择数据获取文本内容
   */
  private async getDataContent (textarea: HTMLInputElement, data: string) {
    const res = await getDataContent(textarea, data).start()
    this.form.dataContent = res.content
  }

  /**
   * 根据选择参数配置获取文本内容
   */
  // private async getConfigContent (textarea: HTMLInputElement, data: string, config: string) {
  //   const getContentRequest = getConfigContent(textarea, { dataName: data, configName: config })
  //   this.form.configContent = await getContentRequest.start()
  // }

  /**
   * 级联选择器数据改变
   */
  private async handleDataChange(value: string) {
    this.form.chooseData = value
    await this.getConfigs()
    await this.getMarker()
    await this.getDataContent(this.dataTextarea, this.form.chooseData)
  }

  /**
   * 显示configs数据
   */
  private async configsHandler () {
    try {
      if(this.configsList.length === 0) {
        this.configsList = await getConfigs(null, this.form.chooseData).start()
      }
    } catch (e) {
      console.warn(e)
    }
    // await this.getConfigContent(this.configTextarea, this.form.chooseData, this.form.configData)
  }

  /**
   * 返回过滤后的数据
   */
  private filterHandler (e: any) {
    this.saveParams = e.params
    this.filterName = e.filterName
  }

  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            job_id: this.id,
            choose_data: this.form.chooseData,
            filter: JSON.stringify(this.saveParams),
            filter_name: this.filterName
          }
          if (this.form.inputType === 'file') {
            params.choose_data = this.form.dataID
          } else {
            params.choose_data = this.form.chooseData
          }
          if (this.form.markerType === 'file') {
            params.marker_id = this.form.markerID
          } else {
            params.marker = this.form.markerData
          }
          if (this.form.configType === 'file') {
            params.config_id = this.form.configID
          } else {
            params.choose_config = this.form.configData
          }
          const taskDetail = await createTask(null, params).start()
          this.$emit('formSubmit', taskDetail)
        } catch (e) {
          console.warn(e)
        }
        this.loadingProcessButton = true
      } else {
        return false
      }
    })
  }

  private get rules () {
    const checkInputData = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'choose' && !value) {
        return callback(new Error(<string>this.$t('form.choose')))
      }
      callback()
    }
    const checkFile = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'file' && !this.form.dataID) {
        return callback(new Error(<string>this.$t('form.upload')))
      }
      callback()
    }
    const checkConfigData = (rule: any, value: string, callback: Function) => {
      if (this.form.configType === 'choose' && !value) {
        return callback(new Error(<string>this.$t('form.choose')))
      }
      callback()
    }
    const checkConfigFile = (rule: any, value: string, callback: Function) => {
      if (this.form.configType === 'file' && !this.form.configID) {
        return callback(new Error(<string>this.$t('form.upload')))
      }
      callback()
    }
    return {
      chooseData: [
        { validator: checkInputData, trigger: 'blur' }
      ],
      fileId: [
        { validator: checkFile, trigger: 'blur' }
      ],
      configData: [
        { validator: checkConfigData, trigger: 'blur' }
      ],
      configFile: [
        { validator: checkConfigFile, trigger: 'blur' }
      ]
    }
  }
}
